const MdastMdxJsEsmVisitor = {
  testNode: "mdxjsEsm",
  visitNode() {
  }
};
export {
  MdastMdxJsEsmVisitor
};
